import React from 'react'

// material ui
import Box from '@mui/material/Box'

// components
import ExpandRow from 'components/atoms/ExpandRow'
import PanelContents from './PanelContents'

// helpers
import { centsToDollars } from 'lib/helpers/money'
import { camperSessionSubtotal } from 'lib/cart/decorators/cartForm'
import { displayDaysRemaining } from 'lib/helpers/account/plans'

// if there is a plan for this session, display days remaining
const panelTitle = (session, camperSession) => {
  const { availableDays, unlimitedDays, registered } = camperSession
  if (registered) {
    return `${session.name} – ${displayDaysRemaining({
      balance: availableDays,
      unlimited: unlimitedDays,
      label: true
    })}`
  }

  return session.name
}

const CamperSession = props => {
  const { camper, session, camperSession, cartForm, defaultOpen, account } = props

  if (!cartForm || !camperSession) {
    return null
  }

  const subtotal = camperSessionSubtotal({ camper, session, cartForm, account })
  const subtitle = subtotal > 0 ? centsToDollars(subtotal) : null

  return (
    <ExpandRow
      title={panelTitle(session, camperSession)}
      subtitle={subtitle}
      defaultOpen={defaultOpen}
    >
      <Box  mt={2} mb={2}>
        <PanelContents {...props} />
      </Box>
    </ExpandRow>
  )
}

export default CamperSession
